module.exports = __webpack_public_path__ + "static/media/wolf2.dbdd6919.jpg";